import { z } from 'zod'

import { DateZod, PiloteBackgroundCheckStatusZod } from '../common'

export const VolunteerZod = z.object({
  code: z.string().optional(),
  active: z.boolean(),
  centralId: z.number(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  phoneNumbers: z.string().array().optional().default([]),
  piloteId: z.number(),
  regionId: z.string(),
  servedClients: z.number().nullish(),
  servedDistance: z.number().nullish(),
  accruedDonations: z.number().nullish(),
  presenceCountForCurrentCampaign: z.number().nullish(),
  registrationCount: z.number().nullish(),
  participationNumberOfYears: z.number().nullish(),
  gender: z.enum(['male', 'female', 'nonBinary']).nullish().default('male'),
  birthDate: DateZod.nullish(),
  backgroundCheckStatus: PiloteBackgroundCheckStatusZod.nullish(),
  backgroundCheckDate: DateZod.nullish(),
})
